import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './NavigationBar.css'; // Import the CSS file

const NavigationBar: React.FC = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <nav className="navbar">
      <div className="container">
        <div className="navbar-content">
          <Link to="/" className="navbar-brand">
            <img src="/logo.png" alt="Dixon Financial Services" className="navbar-logo" />
          </Link>
          
          <button 
            className="navbar-toggle" 
            onClick={toggleMenu}
            aria-label="Toggle navigation menu"
          >
            <span></span>
            <span></span>
            <span></span>
          </button>

          <div className={`navbar-menu ${isMenuOpen ? 'navbar-menu-open' : ''}`}>
            <div className="navbar-nav">
              <Link to="/" className="nav-link" onClick={() => setIsMenuOpen(false)}>
                Home
              </Link>
              <Link to="/about" className="nav-link" onClick={() => setIsMenuOpen(false)}>
                About Us
              </Link>              
              <Link to="/contact" className="nav-link" onClick={() => setIsMenuOpen(false)}>
                Contact
              </Link>
            </div>
            
            <div className="navbar-actions">
              <a 
                href="https://www.cirstatements.com/" 
                target="_blank" 
                rel="noopener noreferrer"
                className="btn btn-secondary client-portal"
              >
                Client Portal
              </a>
            </div>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default NavigationBar; 